<template>
    <import-preview-list
        import-type="appointment"
        path-prefix="appointments"
        ref="preview"
        @back="onBack"
        @complete="onComplete"
    />
</template>

<script>
    import ImportPreviewList from '@/views/Imports/ImportPreviewList.vue';

    export default {
        components: { ImportPreviewList },

        methods: {
            onComplete() {
                this.$router.replace({
                    name: 'appointments',
                });
            },

            onBack() {
                this.$router.replace({
                    name: 'appointments.import.match',
                    params: {
                        id: this.$route.params.id,
                    },
                });
            },
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.$refs.preview.onBeforeRouteEnter();
            });
        },

        beforeRouteLeave(to, from, next) {
            this.$refs.preview.onBeforeRouteLeave(to, next);
        },
    };
</script>
